import { render, staticRenderFns } from "./MSelectColorMvTxt.vue?vue&type=template&id=97ca8100&"
import script from "./MSelectColorMvTxt.vue?vue&type=script&lang=ts&"
export * from "./MSelectColorMvTxt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports